import { Tab } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  a11yProps,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import InstalacionesAsignadasTecnicoPage from '../InstalacionesTecnicoPage/InstalacionesAsignadasTecnicoPage';
import InstallAsignadaTecnicoOTByState from '../InstalacionesTecnicoPage/InstallAsignadaTecnicoOTByState';



export type RetirosTecnicoProps = {};

const RetirosTecnico: React.FC<
  RetirosTecnicoProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);
  const returnUrlRetirosTecnico =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  return (
    <SingleTableBoxScene title={'Retiros'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Asignadas" value={1} {...a11yProps(1)} />
          <Tab label="Asignadas Recoordinadas" value={2} {...a11yProps(2)} />
          {/* <Tab label="Pendientes Actualizar" value={3} {...a11yProps(3)} /> */}
          <Tab label="Realizadas" value={4} {...a11yProps(4)} />
          {/* <Tab label="Realizadas Actualizadas" value={5} {...a11yProps(5)} /> */}
          <Tab label="Pre Rechazadas" value={6} {...a11yProps(6)} />
          <Tab label="Rechazadas" value={7} {...a11yProps(7)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Asignadas ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <InstalacionesAsignadasTecnicoPage />
      </CustomTabPanel>

      {/* ============ Asignadas Recoordinadas ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
          editPath={`${returnUrlRetirosTecnico}/asignadas/recoordinada`}
        />
      </CustomTabPanel>

      {/* ============ Pendientes Actualizar ============ */}
      {/* <CustomTabPanel value={valueTab} index={3}>
        PENDIENTES ACTUALIZAR
      </CustomTabPanel> */}

      {/* ============ Realizadas ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.REALIZADA}
        />
      </CustomTabPanel>

      {/* ============ Realizadas Actualizadas ============ */}
      {/* <CustomTabPanel value={valueTab} index={5}>
        REALIZADAS ACTUALIZADAS
      </CustomTabPanel> */}

      {/* ============ Pre Rechazadas ============ */}
      <CustomTabPanel value={valueTab} index={6}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO}
        />
      </CustomTabPanel>

      {/* ============ Rechazadas ============ */}
      <CustomTabPanel value={valueTab} index={7}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.RECHAZADA}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default RetirosTecnico;
